import { readString } from "react-papaparse";

export async function readCSV(filepath: string, onComplete: any) {
  await fetch(filepath)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response not ok");
      }
      return response.text();
    })
    .then((data) => {
      readString(data, {
        worker: true,
        header: true,
        dynamicTyping: true,
        complete: (results) => {
          onComplete(results.data);
        },
      });
    });
}

export function formatNumber(num: number | string | null): string | null {
  if (num == null) {
    return null;
  }
  const roundedNum = Number(num);
  if (isNaN(roundedNum)) {
    return null;
  }
  if (roundedNum % 1 === 0) {
    return roundedNum.toString();
  } else {
    return roundedNum.toFixed(2);
  }
}

export function chargeCodeInList(offenseCode: string, list: any[]) {
  for (let i = 0; i < list.length; i++) {
    if (list[i]["Charge Code"] === offenseCode) {
      return true;
    }
  }
  return false;
}
